<template>
  <div id="grid-layout">
    <grid-layout
      ref="gridLayout"
      :layout.sync="layout"
      :col-num="colNum"
      :row-height="rowHeight"
      is-draggable
      is-resizable
      :vertical-compact="true"
      :use-css-transforms="true"
      @layout-updated="onLayoutUpdated"
    >
      <grid-item
        v-for="item in layout"
        v-bind:key="item.i"
        :static="item.static"
        :x="item.x"
        :y="item.y"
        :w="item.w"
        :h="item.h"
        :i="item.i"
        :minH="item.minH"
      >
        <component :is="item.component" v-bind="item.settings" :index="item.i" />
      </grid-item>
    </grid-layout>
  </div>
</template>

<script>
import { GridLayout, GridItem } from 'vue-grid-layout';
import Panel from '../components/Panel';

export default {
  name: 'Grid',
  components: {
    GridItem,
    GridLayout,
    Panel,
  },
  props: {
    layout: {
      type: Array,
    },
    colNum: {
      type: Number,
      default: 9,
    },
    rowHeight: {
      type: Number,
      default: 30,
    },
  },
  methods: {
    onLayoutUpdated(val) {
      this.$emit('layout-updated', val);
    },
  },
};
</script>

<style lang="scss" scoped>
.vue-grid-layout::v-deep {
  background: #eee;

  .vue-grid-item .resizing {
    opacity: 0.9;
  }
  .vue-grid-item .static {
    background: #cce;
  }
  .vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
  }
  .vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
  }
  .vue-grid-item .minMax {
    font-size: 12px;
  }
  .vue-grid-item .add {
    cursor: pointer;
  }
  .vue-resizable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    bottom: 0;
    right: 0;
    background: url(data:image/svg+xml;base64,PHN2ZyBzdHlsZT0iYmFja2dyb3VuZC1jb2xvcjojZmZmZmZmMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjYiIGhlaWdodD0iNiI+PHBhdGggZD0iTTYgNkgwVjQuMmg0LjJWMEg2djZ6IiBvcGFjaXR5PSIuMzAyIi8+PC9zdmc+);
    background-position: 100% 100%;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: se-resize;
    transform: scale(1.3);
  }
}
</style>
